import React from 'react';
import Reveal from '../saas/Reveal';

/** مراحل فرایند — گرید بنتو ۲×۲، برچسب مرحله به‌صورت تایپوگرافی (بدون بولت) */
export function ProcessBento({ items }) {
  return (
    <div className="grid grid-cols-1 gap-3 sm:grid-cols-2 sm:gap-4">
      {items.map((text, i) => (
        <Reveal
          key={i}
          delayMs={i * 55}
          className="group relative overflow-hidden rounded-[1.25rem] border border-hairline/40 bg-gradient-to-br from-card-surface via-card-surface to-sky-wash/[0.45] p-5 shadow-saas ring-1 ring-black/[0.02] transition duration-300 ease-out hover:border-signal/25 hover:shadow-saas-md sm:p-6"
        >
          <span className="inline-block font-mono text-[0.7rem] font-semibold uppercase tracking-[0.14em] text-signal/75">
            {(i + 1).toString().padStart(2, '0')}
          </span>
          <p className="mt-3 text-[0.9375rem] font-medium leading-[1.7] tracking-normal text-ink-graphite sm:text-base">
            {text}
          </p>
          <div
            className="pointer-events-none absolute -bottom-8 -end-8 h-24 w-24 rounded-full bg-signal/[0.06] blur-2xl transition-opacity duration-300 group-hover:opacity-100"
            aria-hidden
          />
        </Reveal>
      ))}
    </div>
  );
}
